// components
import { Typography } from '@centria-ui-atoms/typography'

// utils
import { regexValidation } from '@centria-ui/utils/regex'

// styles
import classes from './styles.module.scss'

// types
import type { FC } from 'react'

type SuggestionsTemplateProps = {
  value?: string
  labels?: {
    minSize: string
    hasLetters: string
    hasNumbers: string
    hasSpecials: string
    hasCapitalLetter: string
  }
}

export const SuggestionsTemplate: FC<SuggestionsTemplateProps> = ({
  value,
  labels = {
    minSize: 'La contraseña debe tener al menos 8 caracteres',
    hasLetters: 'La contraseña debe contener al menos una letra',
    hasCapitalLetter:
      'La contraseña debe contener al menos una letra mayúscula',
    hasNumbers: 'La contraseña debe contener al menos un número',
    hasSpecials: 'La contraseña debe contener al menos un carácter especial'
  }
}) => {
  const validated = regexValidation(value as string)
  const suggestionList = [
    {
      value: 'minSize',
      label: labels.minSize
    },
    {
      value: 'hasLetters',
      label: labels.hasLetters
    },
    {
      value: 'hasCapitalLetter',
      label: labels.hasCapitalLetter
    },
    {
      value: 'hasNumbers',
      label: labels.hasNumbers
    },
    {
      value: 'hasSpecials',
      label: labels.hasSpecials
    }
  ]

  return (
    <ul className={classes.suggestionsContainer}>
      {suggestionList.map((suggestion: { value: string; label: string }) => (
        <li key={suggestion.value}>
          <Typography
            fontSize='small'
            fontcolor='light'
            className={`${
              validated[suggestion.value as keyof typeof validated]
                ? classes.check
                : ''
            }`}>
            {suggestion.label}
          </Typography>
        </li>
      ))}
    </ul>
  )
}
